import {httpEndpointCustom, HttpResultSimple} from "../utils/HttpUtils";


export async function invalidateVozidlo(id: number) : Promise<HttpResultSimple> {
    return await httpEndpointCustom(`admin/vozidloview/${id}/invalidate`, {method: "POST"});
}

export async function validateVozidlo(id: number) : Promise<HttpResultSimple> {
    return await httpEndpointCustom(`admin/vozidloview/${id}/validate`, {method: "POST"});
}